export const translations = {
  es: {
    // Amar Names
    'amar.presence.name': 'Presencia',
    'amar.benevolence.name': 'Benevolencia',
    'amar.compassion.name': 'Compasión',
    'amar.perdon.name': 'Perdón',
    'amar.mercy.name': 'Misericordia',
    'amar.appreciate.name': 'Apreciar',
    'amar.agradecer.name': 'Agradecer',
    'amar.admiration.name': 'Admirar',
    'amar.honor.name': 'Honrar',
    'amar.devotion.name': 'Devoción',
    'amar.communion.name': 'Comunión',
    'amar.brotherhood.name': 'Hermanar',
    'amar.friendship.name': 'Amistad',
    'amar.ecstasy.name': 'Éxtasis',
    'amar.eros.name': 'Eros',
    'amar.excitement.name': 'Excitación',
    'amar.play.name': 'Juego y Placer',

    // Amar Category Names
    'category.presence.name': 'Presencia',
    'category.compasivos.name': 'Amares Compasivos',
    'category.admirativos.name': 'Amares Admirativos',
    'category.fraternales.name': 'Amares Fraternales',
    'category.eroticos.name': 'Amares Eróticos',

    // Wheel of Life Area Names
    'wol.health.name': 'Salud y Bienestar',
    'wol.love.name': 'Amor y Pareja',
    'wol.family.name': 'Familia y Amigos',
    'wol.career.name': 'Carrera / Propósito',
    'wol.finance.name': 'Finanzas',
    'wol.personalGrowth.name': 'Crecimiento Personal',
    'wol.leisure.name': 'Ocio y Diversión',
    'wol.environment.name': 'Entorno Físico',

    // Bottom Nav
    'nav.today': 'Hoy',
    'nav.counselor': 'Consejero',
    'nav.plan': 'Plan',
    'nav.progress': 'Progreso',
    'nav.journal': 'Diario',
    'nav.school': 'Escuela',
    
    // MyDay Screen
    'myday.title': 'Hoy',
    'myday.admin_panel_link': 'Ir al panel de Admin',
    'myday.practices_title': 'Prácticas para Hoy',
    'myday.no_practices': 'No hay prácticas planeadas para hoy. ¿Quizás una práctica libre?',
    'myday.practice_time_aria': 'Hora de la práctica, actualmente {{time}}',
    'myday.read_article': 'Leer artículo',
    'myday.watch_video': 'Ver video',
    'myday.listen_meditation': 'Escuchar meditación',
    'myday.view_content': 'Ver contenido',
    'myday.reflection_title': 'Reflexión del Día',
    'myday.day_rating_label': '¿Cómo calificarías tu día de hoy?',
    'myday.notes_label': 'Mis notas sobre hoy',
    'myday.notes_placeholder': '¿Cómo te sentiste? ¿Qué notaste?',
    'myday.voice_note_label': 'Grabar una nota de voz',
    'myday.delete_audio': 'Borrar',
    'myday.record_button_start': 'Grabar y Transcribir',
    'myday.record_button_stop': 'Detener Grabación',
    'myday.record_button_transcribing': 'Transcribiendo...',
    'myday.mic_error': 'No se pudo acceder al micrófono.',
    'myday.wheel_of_life_title': 'Rueda de la Vida',
    'myday.customize_objectives': 'Personalizar Objetivos',
    'myday.save_reflection_button': 'Guardar Reflexión',
    'myday.reflection_saved_alert': 'Reflexión guardada.',
    'myday.get_suggestion_button': 'Obtener Sugerencia para Mañana',
    'myday.analyzing_day': 'Analizando tu día...',
    'myday.suggestion_error': 'Por favor, guarda tu reflexión del día primero.',
    'myday.tomorrow_suggestion_title': 'Sugerencia para mañana:',
    'myday.practice_added_notice': 'Para ayudarte, he añadido la práctica "{{practiceTitle}}" a tu plan de mañana.',
    'myday.log_free_practice': 'Registrar Práctica Libre',
    'myday.share_modal_title': '¡Práctica de {{amarName}} registrada!',
    'myday.share_modal_text': 'Se generará una imagen para compartir en redes sociales como Instagram. ¿Quieres continuar?',
    'myday.share_modal_confirm': 'Crear y Compartir',
    'myday.share_modal_generating': 'Generando imagen...',
    'myday.share_modal_cancel': 'Ahora no',
    'myday.share_error': 'Error al compartir. Es posible que tu navegador no soporte compartir imágenes.',

  },
  en: {
    // Amar Names
    'amar.presence.name': 'Presence',
    'amar.benevolence.name': 'Benevolence',
    'amar.compassion.name': 'Compassion',
    'amar.perdon.name': 'Forgiveness',
    'amar.mercy.name': 'Mercy',
    'amar.appreciate.name': 'Appreciation',
    'amar.agradecer.name': 'Gratitude',
    'amar.admiration.name': 'Admiration',
    'amar.honor.name': 'Honor',
    'amar.devotion.name': 'Devotion',
    'amar.communion.name': 'Communion',
    'amar.brotherhood.name': 'Brotherhood',
    'amar.friendship.name': 'Friendship',
    'amar.ecstasy.name': 'Ecstasy',
    'amar.eros.name': 'Eros',
    'amar.excitement.name': 'Excitement',
    'amar.play.name': 'Play & Pleasure',

    // Amar Category Names
    'category.presence.name': 'Presence',
    'category.compasivos.name': 'Compassionate Amares',
    'category.admirativos.name': 'Admirative Amares',
    'category.fraternales.name': 'Fraternal Amares',
    'category.eroticos.name': 'Erotic Amares',

    // Wheel of Life Area Names
    'wol.health.name': 'Health & Wellness',
    'wol.love.name': 'Love & Partner',
    'wol.family.name': 'Family & Friends',
    'wol.career.name': 'Career / Purpose',
    'wol.finance.name': 'Finances',
    'wol.personalGrowth.name': 'Personal Growth',
    'wol.leisure.name': 'Leisure & Fun',
    'wol.environment.name': 'Physical Environment',

    // Bottom Nav
    'nav.today': 'Today',
    'nav.counselor': 'Counselor',
    'nav.plan': 'Plan',
    'nav.progress': 'Progress',
    'nav.journal': 'Journal',
    'nav.school': 'School',
    
    // MyDay Screen
    'myday.title': 'Today',
    'myday.admin_panel_link': 'Go to Admin Panel',
    'myday.practices_title': "Today's Practices",
    'myday.no_practices': 'No practices planned for today. Maybe a free practice?',
    'myday.practice_time_aria': "Practice time, currently {{time}}",
    'myday.read_article': 'Read article',
    'myday.watch_video': 'Watch video',
    'myday.listen_meditation': 'Listen to meditation',
    'myday.view_content': 'View content',
    'myday.reflection_title': "Day's Reflection",
    'myday.day_rating_label': 'How would you rate your day today?',
    'myday.notes_label': 'My notes on today',
    'myday.notes_placeholder': 'How did you feel? What did you notice?',
    'myday.voice_note_label': 'Record a voice note',
    'myday.delete_audio': 'Delete',
    'myday.record_button_start': 'Record and Transcribe',
    'myday.record_button_stop': 'Stop Recording',
    'myday.record_button_transcribing': 'Transcribing...',
    'myday.mic_error': 'Could not access the microphone.',
    'myday.wheel_of_life_title': 'Wheel of Life',
    'myday.customize_objectives': 'Customize Objectives',
    'myday.save_reflection_button': 'Save Reflection',
    'myday.reflection_saved_alert': 'Reflection saved.',
    'myday.get_suggestion_button': "Get Tomorrow's Suggestion",
    'myday.analyzing_day': 'Analyzing your day...',
    'myday.suggestion_error': 'Please save your reflection for the day first.',
    'myday.tomorrow_suggestion_title': "Tomorrow's suggestion:",
    'myday.practice_added_notice': 'To help you, I have added the "{{practiceTitle}}" practice to your plan for tomorrow.',
    'myday.log_free_practice': 'Log Free Practice',
    'myday.share_modal_title': '{{amarName}} practice logged!',
    'myday.share_modal_text': 'An image will be generated to share on social media like Instagram. Do you want to continue?',
    'myday.share_modal_confirm': 'Create and Share',
    'myday.share_modal_generating': 'Generating image...',
    'myday.share_modal_cancel': 'Not now',
    'myday.share_error': 'Error sharing. Your browser may not support sharing images.',
  }
};